import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Fires on every route change and scrolls the window to the top instantly.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
